import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiVersionEndPointUrl, BaseUrl } from "../utils/systemEnums";
import { DataService } from "./data.service";
import { LocalStoreService } from "./local-store.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class AuthServiceLocal {

    // this.userProfilePic = JSON.parse(localStorage.getItem('loggedUser'))?.profileImage;


    userProfilePic: BehaviorSubject<string> = new BehaviorSubject('');
    _configuration = {
        API_ENDPOINT: BaseUrl,
        // API_ENDPOINT_V5: ApiEndPointUrlV5,
        // BANK_API_ENDPOINT : BankListEndPointUrl,
    };

    constructor(
        private router: Router,
        private _dataService: DataService,
        private store: LocalStoreService
    ) { }

    isLoggedIn() {
        if (this.store.getItem("token")) {
            return true;
        }
        return false;
    }

    getToken() {
        return this.store.getItem("token");
    }

    getUser() {
        return this.store.getItem("loggedUser");
    }

    /**
     *  Auth Module
     * */
    public ChangePassword(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affliate-changePassword`,
            body
        );
    }

    public affiliateLogin(body) {
        return this._dataService.postDataWithoutHeader(
            // this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/web/affliate-login",
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/web/affliate-login`,
            body
        );
    }

    public affiliateSignUp(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affliate-signup`,
            body
        );
    }

    public checkForChangeStatus(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/get-affiliate-status`,
            body
        );
    }

    public forgotPassword(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affliate-forgotPassword`,
            body
        );
    }

    public resetPassword(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affliate-resetPassword`,
            body
        );
    }

    public checkMobileExist(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/common/web/numberChecker`,
            body
        );
    }

    public checkEmailExist(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/common/web/emailChecker`,
            body
        );
    }

    public sendOTPViaWhatsApp(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/affiliate-send-message`,
            body
        );
    }

    public sendOTPViaCall(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/affiliate-get-otp-over-call`,
            body
        );
    }

    public affiliateVerifyOTP(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/affiliate-verify-phone`,
            body
        );
    }

    /**
     * requestWithdrawal Module
     * */
    public getWithdrawalList() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-withdrawalList`
        );
    }

    public requestWithdrawal(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-requestForWithdrawal`,
            body
        );
    }

    /*
     * Commission Withdrawal module
     */

    public getCommissionWithdrawalList(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-CommisionWithdrawalList`,
            body
        );
    }

    public requestCommissionWithdrawal(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-requestForCommisionWithdrawal`,
            body
        );
    }

    public getMinMaxAmount(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-balacesheet-List`,
            body
        );
    }

    /**
     * Get Total Amount
     * */
    public getCommissionWithdrawalTotalAmount(body) {
        return this._dataService.postDataWithHeader(this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/web/affiliate-get-total-commision-amount`,
            body
        );
    }

    /**
     * How It Works Module
     * */
    public getHowItWorksData(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/common/web/howToAffiliates`,
            body
        );
    }

    /**
     * Dashboard Module
     * */
    public getDashboard() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-dashBoard`
        );
    }

    public generateLink(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/genrateDynamicLink`,
            body
        );
    }

    public generatePDASLink(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/genrateDeliveryDynamicLink`,
            body
        );
    }

    public customizeAffiliateRedirectionLink(body) {
        return this._dataService.putDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/customize-affiliate-link`,
            body
        );
    }
    /**
     * User Detail
     * */
    public getProfile() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-getProfile`
        );
    }

    /**
     * Get all Affiliated Detail
     * */
    public getAllAffiliatedUsers() {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/getListOfAffiliatesJoinedBasedOnLink`,
            ""
        );
    }
    /**
     * Get Total Amount
     * */
    public getTotalAmount() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-get-total-amount`
        );
    }

    /**
     * Bank Detail
     * */
    public getBankDetailByCountry(country) {
        return this._dataService.getData(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/get-all-banks/` + country
        );
    }

    public getBranchListByBank(id) {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/aff-get-branch-list/` +
            id
        );
    }

    public getBankDetailByUser() {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/get-affliate-BankDetails`,
            ""
        );
    }

    public addBankDetail(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/add-affliate-details`,
            body
        );
    }

    public updateBankDetail(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/update-affliate-details`,
            body
        );
    }

    /**
     * Help Module
     */
    public help(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/web/affiliate-help`,
            body
        );
    }

    public uploadDocuments(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/uploadAffiliateDocument`,
            body
        );
    }

    public uploadDocumentImage(body) {
        // return this._dataService.postDataWithHeader(
        //     this._configuration.API_ENDPOINT +
        //     `api/${ApiVersionEndPointUrl}/account/uploadAffiliateDocumentImage`,
        //     body
        // );

        return new Promise((resolve, reject) => {
            this._dataService.postDataWithHeaderFormData(this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/uploadAffiliateDocumentImage`, body).subscribe((res: any) => {
                resolve(res)
            }, reject);
        })
    }

    public getUserDocuments() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/account/web/getAffiliateDocs`
        );
    }

    public getOrderCommisionForAffiliate(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/getOrderCommisionForAffiliate`,
            body
        );
    }

    public getAffiliateEarningTiers() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-earning-tiers`
        );
    }

    public chooseAffiliateTiear(payload) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/choose-affiliate-tiear`,
            payload
        );
    }

    public getContentHIW() {
        return this._dataService.getData(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/get-affiliate-earning-content`
        );
    }

    public getTermsAndConditions() {
        return this._dataService.getData(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/get-affiliate-terms-conditions`
        );
    }

    public getGuidelineContent() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/get-affiliate-guideline-content`
        );
    }

    public getFAQsData() {
        return this._dataService.getData(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-earning-faq`
        );
    }

    public getSocialPostTemplates() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-post-template`
        );
    }

    public getToolkitData() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/affiliate-toolkit-banner`
        );
    }

    public saveAffiliateCode(body) {
        return this._dataService.putDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/customize-affiliate-code`,
            body
        );
    }

    public checkPhoneNumber(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/check-affiliate-user`,
            body
        );
    }

    public affiliateUserExists(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/check-affiliate-user-exists`,
            body
        );
    }

    public affiliateSendForgotPasswordMessage(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/affiliate-send-forgot-password-message`,
            body
        );
    }

    public affiliateSendForgotPasswordCall(body) {
        return this._dataService.postDataWithoutHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/web/affiliate-forgot-password-otp-call`,
            body
        );
    }

    // public affiliateVerifyPhone(body) {
    //   return this._dataService.postDataWithoutHeader(
    //        this._configuration.API_ENDPOINT + 'api/${ApiVersionEndPointUrl}/common/web/affiliate-verify-phone', body
    //   );
    // }

    public uploadCommonImage(image) {
        return new Promise((resolve, reject) => {
            this._dataService.postDataWithoutHeaderFormData(this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/common/upload-image`, image).subscribe((res: any) => {
                resolve(res)
            }, reject);
        })
        // return this._dataService.postDataWithoutHeaderFormData(
        //     this._configuration.API_ENDPOINT + `api/${ApiVersionEndPointUrl}/common/web/upload-image",
        //     image
        // );
    }

    public getAllBanksForMobileMoney(country) {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/common/get-all-banks/${country}`
        );
    }

    public addMobileMoney(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/add-nupdate-affiliate-wallet-details`,
            body
        );
    }

    public onSaveProfileImage(body) {
        return this._dataService.postDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/update-profile-pic`,
            body
        );
    }

    public getMobileMoneyDetails() {
        return this._dataService.getDataWithHeader(
            this._configuration.API_ENDPOINT +
            `api/${ApiVersionEndPointUrl}/account/web/get-affilite-bank-nwallet-detail`
        );
    }

}
